module.exports = __webpack_public_path__ + "img/LandschaftII.35aa74b4.jpg";